/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AffiliatePaymentDetailDto
 */
export interface AffiliatePaymentDetailDto {
    /**
     * 
     * @type {Date}
     * @memberof AffiliatePaymentDetailDto
     */
    date: Date;
    /**
     * 
     * @type {string}
     * @memberof AffiliatePaymentDetailDto
     */
    email: string;
    /**
     * 
     * @type {number}
     * @memberof AffiliatePaymentDetailDto
     */
    amount: number;
    /**
     * 
     * @type {number}
     * @memberof AffiliatePaymentDetailDto
     */
    commission: number;
}

export function AffiliatePaymentDetailDtoFromJSON(json: any): AffiliatePaymentDetailDto {
    return AffiliatePaymentDetailDtoFromJSONTyped(json, false);
}

export function AffiliatePaymentDetailDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AffiliatePaymentDetailDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': (new Date(json['date'])),
        'email': json['email'],
        'amount': json['amount'],
        'commission': json['commission'],
    };
}

export function AffiliatePaymentDetailDtoToJSON(value?: AffiliatePaymentDetailDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': (value.date.toISOString()),
        'email': value.email,
        'amount': value.amount,
        'commission': value.commission,
    };
}

